function assertNonNullish<T> (
  value: T,
  message?: string
): asserts value is NonNullable<T> {
  if (value === null) {
    throw TypeError(message != null ? message : 'Object should not be null');
  }

  if (value === undefined) {
    throw TypeError(message != null ? message : 'Object should not be undefined');
  }
}

function requireNonNullish<T> (
  value: T,
  message?: string
): NonNullable<T> {
  assertNonNullish(value, message);
  return value;
}

export {
  assertNonNullish,
  requireNonNullish
};
